webpackJsonp([124022590561549],{

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ValuePagesTemplate = __webpack_require__(74);
	
	var _ValuePagesTemplate2 = _interopRequireDefault(_ValuePagesTemplate);
	
	var _Text = __webpack_require__(55);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _PageTitle = __webpack_require__(54);
	
	var _PageTitle2 = _interopRequireDefault(_PageTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConversationsPage = function ConversationsPage() {
	    return _react2.default.createElement(
	        _ValuePagesTemplate2.default,
	        null,
	        _react2.default.createElement(_PageTitle2.default, { title: 'Candid Conversations' }),
	        _react2.default.createElement(
	            _Text2.default,
	            null,
	            'We have real, honest conversations. We\'d rather come across as aggressive and obnoxious than manipulative and insincere.'
	        ),
	        _react2.default.createElement(
	            _Text2.default,
	            null,
	            'We challenge directly because we care personally.'
	        )
	    );
	};
	
	exports.default = ConversationsPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-candid-conversations-js-3ccc8e902dcf79e45aac.js